import React from 'react';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { Button } from '@mui/material';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { CenteredFlexBox } from '../../../../Components/FlexBox';

const ActionButtons = function ActionButtons({
  returnToSelection,
  handleConfirm,
  confirmed = false,
}) {
  const intl = useIntl();
  const methods = useFormContext();

  return (
    <CenteredFlexBox padding="16px" justifyContent="space-between">
      <Button
        variant="outlined"
        color="primary"
        sx={{ width: '140px' }}
        onClick={() => {
          if (confirmed) {
            return handleConfirm();
          }
          return returnToSelection();
        }}
      >
        {intl.messages.BACK}
      </Button>
      <Button
        variant={confirmed ? 'contained' : 'outlined'}
        type={confirmed ? 'submit' : 'button'}
        color="primary"
        sx={{ width: '140px' }}
        startIcon={<CheckCircleOutlinedIcon />}
        onClick={async (e) => {
          if (!confirmed) {
            e.preventDefault();
            const result = await methods.trigger();
            if (result) return handleConfirm();
          }
        }}
      >
        {intl.messages.CONFIRM}
      </Button>
    </CenteredFlexBox>
  );
};

export default ActionButtons;
